import { DateTime } from 'luxon'
import React from 'react'
import { useIntl } from 'react-intl'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { Spinner } from '../../widgets/components/General/Spinner'
import NoDataPage from '../../widgets/components/NoDataPage'

export const Updates = ({
  investorUpdatesData,
  investorUpdatesApiLoading,
  publicCompanyPageLoading,
  publicStatus
}: {
  investorUpdatesData: any
  investorUpdatesApiLoading: boolean
  publicCompanyPageLoading: boolean
  publicStatus: boolean | undefined

}) => {
  const { formatMessage } = useIntl()
  const { getDateValue } = useDateFormat()

  return (
    <>
      {(publicStatus === false ? investorUpdatesApiLoading : publicCompanyPageLoading) ? <Spinner /> : null}
      {!investorUpdatesApiLoading && investorUpdatesData?.length === 0 ? (
        <div className='card p-7 mt-6 company-page-dark'>
          <NoDataPage bgTransparent />
        </div>
      ) : (
        <div className='card p-7 mt-6 company-page-dark'>
          <div className='table-responsive'>
            <table className='table table-row-bordered align-middle gs-1 gy-3 mt-0'>
              <thead className='font-size-12 text-clr88'>
                <tr className='fw-bold text-muted border-bottom-1 col-12'>
                  <th className='min-w-200px table-header col-5 font-weight-400'>
                    {formatMessage({ id: 'Title' })}
                  </th>
                  <th className='min-w-200px table-header col-5 font-weight-400'>
                    {formatMessage({ id: 'Update time' })}
                  </th>
                  <th className='min-w-200px table-header col-1 text-end font-weight-400 pe-5'>
                    {formatMessage({ id: 'Actions' })}
                  </th>
                </tr>
              </thead>
              <tbody>
                {investorUpdatesData &&
                  investorUpdatesData?.map((update: any) => (
                    <tr className='fw-normal' key={update.updateId}>
                      <td className='form-label'>
                        <span className='font-size-13 form-label font-weight-400'>
                          {update?.title ? update.title : '-'}
                        </span>
                      </td>

                      <td>
                        <span className='font-size-13 form-label font-weight-400'>
                          {update?.createdAt
                            ? getDateValue(new Date(update?.createdAt).toISOString()?.toString())
                              ? getDateValue(new Date(update?.createdAt).toISOString()?.toString())
                              : DateTime.fromISO(
                                new Date(update?.createdAt).toISOString()?.toString()
                              ).toLocaleString(DateTime.DATE_MED)
                            : '-'}
                        </span>
                      </td>
                      <td className='d-flex justify-content-end align-items-center gap-4 '>
                        <div className='d-block mb-1 table-body font-size-13 form-label font-weight-400'>
                          <button
                            className='btn bg-light custom-button-property text-muted font-weight-400 font-size-13 h-35px d-flex align-items-center'
                            onClick={() => window.open(`/updates/view/${update?.uuid}`, '_blank')}
                          >
                            {formatMessage({ id: 'View' })}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}
